import { matchSorter } from 'match-sorter';
import _omit from 'lodash-es/omit';

function punctuationLess(s: string): string {
  const res = s.replace(/[^\w\s]|_/g, '').replace(/\s+/g, ' ');
  return res;
}

interface ObjectWithNom {
  nom: string;
}

export function findByNom<T extends ObjectWithNom>(
  search: string,
  list: T[],
): T | undefined {
  const match = matchSorter(
    (list || []).map(i => ({ ...i, normalizedNom: punctuationLess(i.nom) })),
    punctuationLess(search).trim(),
    {
      keys: ['normalizedNom'],
      threshold: matchSorter.rankings.MATCHES,
    },
  )[0];
  if (match) {
    return _omit(match as any, 'normalizedNom') as T;
  }
  return undefined;
}
